let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bfhS3")).then(() => parcelRequire('5NDsz'));